import { useAuth } from "react-oidc-context";

export function useIsLoggedIn() {
  return useAuth().isAuthenticated;
}
